/**
 * Centralized React Query keys for the console. Keeping them in one place keeps
 * invalidation after a mutation honest (list + detail stay in sync).
 */

export const queryKeys = {
  tenants: ['tenants'] as const,
  tenant: (id: string) => ['tenants', id] as const,
  tenantOwner: (id: string) => ['tenants', id, 'owner'] as const,
  tenantAudit: (
    id: string,
    filter: { readonly action: string | null; readonly entityType: string | null },
  ) => ['tenants', id, 'audit', filter.action, filter.entityType] as const,
};
